import { request } from "@/api/request"

/** 退费列表（已提交） */
export function fetchRefundList(payload = {}) {
  return request.post("/mgm-crm-api/refund/list", payload).then(r => r.data)
}

/** 退费审批列表（待处理 / 已处理） */
export function fetchRefundApprovalList(payload = {}) {
  return request.post("/mgm-crm-api/refund/query-approval-list", payload).then(r => r.data)
}

/** 退费详情 */
export function fetchRefundDetail(id) {
  return request.get(`/mgm-crm-api/refund/detail/${id}`).then(r => r.data)
}

/** 申请退费 */
export function applyRefund(payload = {}) {
  return request.post("/mgm-crm-api/refund/apply", payload).then(r => r.data)
}

/** 取消退费申请 */
export function cancelRefundApply(payload = {}) {
  return request.post("/mgm-crm-api/refund/approve-cancel", payload).then(r => r.data)
}

/** 审核通过 */
export function approveRefundPass(payload = {}) {
  return request.post("/mgm-crm-api/refund/approve-pass", payload).then(r => r.data)
}

/** 审核驳回 */
export function approveRefundReject(payload = {}) {
  return request.post("/mgm-crm-api/refund/approve-reject", payload).then(r => r.data)
}

/** 可退费收入列表 */
export function fetchRefundableIncomeList(payload = {}) {
  return request.post("/mgm-crm-api/refund/refundable-income/list", payload).then(r => r.data)
}

/** 未转完课包列表 */
export function fetchUntransferredCoursePackageList(payload = {}) {
  return request.post("/mgm-crm-api/refund/untransferred-course-package/list", payload).then(r => r.data)
}
